module.exports = __webpack_public_path__ + "img/rhombus-red.a01303be.svg";